import PlanoCard from '../components/planos/CardPlano';
import Sidebar from '../components/SideBar';
import '../styles/planosStyle/Planos.css';
import InfoPlano from '../components/planos/InfoPlano';

export default function Planos() {
  return (
    <div style={{ display: 'flex', background: '#f5f5f5' }}>
      <Sidebar />
      <div className="planos-container">
        <div style={{ padding: '40px 60px' }}>
          <h2>Escolha o plano ideal para você</h2>
          <p>Compare nossos planos e encontre o que melhor atende suas necessidades.</p>
          
          <InfoPlano />

          <div className="cards-wrapper">
            <PlanoCard
              titulo="Básico"
              tipo="básico"
              valor='R$ 200,00'
              beneficios={[
                'Dashboard',
                '1 usuário cadastrado',
                '1 Cidade',
                '1 Segmento',
                'Mapa interativo',
                'Lista de Empreendimentos'
              ]}
              desabilitados={[
                'Socioeconômico',
                'Relatórios em PDF',
                'Tabelas de precificação',
                'IA integrada'
              ]}
              onClick={() => alert('Contato - Básico')}
            />

            <PlanoCard
              titulo="Profissional"
              destaque
              tipo="profissional"
              valor='R$ 799,00'
              beneficios={[
                'Dashboard',
                '1 usuário cadastrado',
                '3 Cidades',
                '3 Segmentos',
                'Mapa interativo',
                'Lista de Empreendimentos',
                'Socioeconômico da cidade',
                'Relatórios em PDF',
                'Tabelas de precificação'
              ]}
              desabilitados={[
                'IA integrada',
              ]}
              onClick={() => alert('Contato - Profissional')}
            />

            <PlanoCard
              titulo="Premium"
              tipo="empresarial"
              valor='Sob Consulta'
              beneficios={[
                'Dashboard',
                '3 usuários cadastrado',
                'Região Metrolitana',
                'Todos os Segmentos',
                'Mapa interativo',
                'Lista de Empreendimentos',
                'Socioeconômico do Estado',
                'Relatórios em PDF',
                'Tabelas de precificação',
                'IA integrada (Em breve)',
              ]}
              onClick={() => alert('Contato - Empresarial')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
